module.exports = __webpack_public_path__ + "static/img/15.f757565.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/6/1/sp/15.png
// module id = W+/S
// module chunks = 0